var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"data-filter",attrs:{"type":"text","placeholder":_vm.translate.data_filter_placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.onFilter($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }